/* Details */

import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { createSelector } from 'reselect'
import { useSelector, useDispatch } from 'react-redux'
import { Box, Container, CircularProgress } from '@material-ui/core'
import { getLastReservationDetails } from '../../services/FirebaseServices/reservationServices'

//HELPERS
import { formatSlugToUrl, getNameCategory } from '../../utils/helpers'

//Componentes

import AgencyBanner from '../../components/AgencyBanner/AgencyBanner'
import RestaurantMenu from '../RestaurantMenu/RestaurantMenu'
import Footer from '../../components/Footer/Footer'
import Ecommerce from '../Ecommerce/Ecommerce'

//Api
import {
  getExperienceById,
  getExperienceByUrl,
  getExperienceGallery,
  getExperienceReviews,
} from '../../services/FirebaseServices/experienceServices'

import {
  getAgencyById,
  getAgencyByUrl,
} from '../../services/FirebaseServices/agencyServices'

//Styles
import './styles.scss'

//Redux
import {
  makeSelectSingleExperience,
  makeSelectAgency,
  makeSelectHasSlug,
  set_single_experience,
  set_agency,
  set_is_experience_active,
  set_has_slug,
} from '../../redux/ducks/experiences'

import { clean_reservation_details } from '../../redux/ducks/reservationDetails'

import { clean_verify_reservation } from '../../redux/ducks/verifyReservation'

import { clean_reservation_info } from '../../redux/ducks/reservationInfo'
import ExperienceInformationHotel from '../../components/ExperienceInformation/ExperienceInformationHotel'
import ExperienceInformationAgency from '../../components/ExperienceInformation/ExperienceInformationAgency'
import MetaTags from 'react-meta-tags'
import { LazyLoadImage } from 'react-lazy-load-image-component'

// Assets
import usaFlag from '../../assets/img/usa.webp'
import chileFlag from '../../assets/img/chile.webp'
import ExperienceInformationPrograms from '../../components/ExperienceInformation/ExperienceInformationPrograms'

const stateSelector = createSelector(
  [makeSelectSingleExperience, makeSelectAgency, makeSelectHasSlug],
  (singleExperience, agency, hasSlug) => ({
    singleExperience,
    agency,
    hasSlug,
  }),
)

const actionDispatch = (dispatch) => ({
  setIsExperienceIsActive: (isExperienceActive) =>
    dispatch(set_is_experience_active(isExperienceActive)),
  setSingleExperience: (experience) =>
    dispatch(set_single_experience(experience)),
  setAgency: (agency) => dispatch(set_agency(agency)),
  setHasSlug: (hasSlug) => dispatch(set_has_slug(hasSlug)),
  cleanReservationDetails: () => dispatch(clean_reservation_details()),
  cleanVerifyReservation: () => dispatch(clean_verify_reservation()),
  cleanReservationInfo: () => dispatch(clean_reservation_info()),
})

const Details = () => {
  const pathSegments = window.location.pathname.split('/').filter(Boolean)
  const [agencyId, experienceId, reservationId, couponId] = pathSegments
  const history = useHistory()
  //STATES REDUX
  const { singleExperience, agency } = useSelector(stateSelector)
  const {
    setIsExperienceIsActive,
    setSingleExperience,
    setAgency,
    cleanReservationDetails,
    cleanVerifyReservation,
    cleanReservationInfo,
  } = actionDispatch(useDispatch())
  //STATES COMPONENTE
  const [isLoading, setIsLoading] = useState(true)
  const [gallery, setGallery] = useState([])
  const [galleryExperiencesProgram, setGalleryExperiencesProgram] = useState([])
  const [reviews, setReviews] = useState([])
  const [h1Hidden, setH1Hidden] = useState([])
  const [h2Hidden, setH2Hidden] = useState([])
  const [title, setTitle] = useState('')
  const [agencyData, setAgencyData] = useState({})
  const [reservationDetail, setReservationDetail] = useState({})
  const [singleExper, setSingleExper] = useState()
  const [lang, setLang] = useState('en')
  useEffect(() => {
    // getImagesOfProgramExperiences()
    fetchData()
    return function cleanup() {
      cleanReservationDetails()
      cleanVerifyReservation()
      cleanReservationInfo()
    }
  }, [])
  useEffect(() => {
    const fetchExperience = async () => {
      const getExperience = await getExperienceById(experienceId)
      return getExperience
    }
    const fetchData = async () => {
      const singleExp = await fetchExperience()
      setSingleExper(singleExp)
    }
    fetchData()
  }, [experienceId])

  const fetchData = async () => {
    try {
      if (!!reservationId && !!couponId) {
        const reservationDeail = await getLastReservationDetails(
          agencyId,
          experienceId,
          reservationId,
          couponId,
        )

        setReservationDetail(reservationDeail)
      } else if (agencyId && experienceId && reservationId) {
        const reservationDeail = await getLastReservationDetails(
          agencyId,
          experienceId,
          reservationId,
          // couponId,
        )

        setReservationDetail(reservationDeail)
      }

      const agencyResponse = await getAgencyById(agencyId)

      if (agencyResponse) {
        const experienceResponse = await getExperienceById(experienceId)
        if (!experienceResponse.isActive || experienceResponse.isDisable) {
          setIsExperienceIsActive(false)
          history.push(`/${agencyId}`)
          return
        }

        setTitle(
          `${capitalize(
            !!experienceResponse.seo
              ? experienceResponse.seo.title
              : experienceResponse.name,
          )} - ${
            !!agencyResponse.locator
              ? getNameLocation(agencyResponse.locator)
              : 'Chile'
          } - ${capitalize(agencyResponse.name)}`,
        )
        setH1Hidden(
          `${experienceResponse.name} - ${
            !!agencyResponse.locator
              ? getNameLocation(agencyResponse.locator)
              : 'Chile'
          } - ${capitalize(agencyResponse.name)}`,
        )
        setH2Hidden(
          `${
            !!experienceResponse.shortDescription
              ? experienceResponse.shortDescription
              : 'Visita nuestra mejor experiencia'
          } - ${experienceResponse.description} - ${getNameLocation(
            experienceResponse.locator,
          )}`,
        )
        const galleryReponse = await getExperienceGallery(
          agencyResponse.key,
          experienceResponse.key,
        )

        const validImages = galleryReponse.filter((item) => item !== '')

        const reviewReponse = await getExperienceReviews(
          agencyResponse.key,
          experienceResponse.key,
        )
        setAgency(agencyResponse)
        setSingleExperience(experienceResponse)
        setGallery(validImages)
        setReviews(reviewReponse)
        setIsLoading(false)
      } else {
        const agencyURLResponse = await getAgencyByUrl(agencyId)

        const experienceURLResponse = await getExperienceByUrl(
          agencyURLResponse.key,
          formatSlugToUrl(experienceId),
        )

        if (
          !experienceURLResponse.isActive ||
          experienceURLResponse.isDisable
        ) {
          setIsExperienceIsActive(false)
          history.push(`/${agencyId}`)
        }

        const galleryReponse = await getExperienceGallery(
          agencyURLResponse.key,
          experienceURLResponse.key,
        )
        const validImages = galleryReponse.filter((item) => item !== '')

        const reviewReponse = await getExperienceReviews(
          agencyURLResponse.key,
          experienceURLResponse.key,
        )

        // SET TITLE
        setTitle(
          `${capitalize(
            !!experienceURLResponse.seo
              ? experienceURLResponse.seo.title
              : experienceURLResponse.name,
          )} - ${
            !!agencyURLResponse.locator
              ? getNameLocation(agencyURLResponse.locator)
              : 'Chile'
          } - ${capitalize(agencyURLResponse.name)}`,
        )
        setH1Hidden(
          `${experienceURLResponse.name} - ${
            !!agencyURLResponse.locator
              ? getNameLocation(agencyURLResponse.locator)
              : 'Chile'
          } - ${capitalize(agencyURLResponse.name)}`,
        )
        setH2Hidden(
          `${
            !!experienceURLResponse.shortDescription
              ? experienceURLResponse.shortDescription
              : 'Visita nuestra mejor experiencia'
          } - ${experienceURLResponse.description} - ${getNameLocation(
            experienceURLResponse.locator,
          )}`,
        )
        setAgency(agencyURLResponse)
        setAgencyData(agencyURLResponse)
        setSingleExperience(experienceURLResponse)
        setGallery(validImages)
        setReviews(reviewReponse)
        setIsLoading(false)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const capitalize = (str) => {
    const lower = str.toLowerCase()
    return str.charAt(0).toUpperCase() + lower.slice(1)
  }

  const getNameLocation = (locator) => {
    if (!!locator) {
      const address = locator.address_components
      if (!!address) {
        const filtered_region = address.filter(function (address_component) {
          return address_component.types.includes('administrative_area_level_1')
        })
        const region = filtered_region.length
          ? filtered_region[0].long_name
          : ''
        const filtered_comuna = address.filter(function (address_component) {
          return address_component.types.includes('administrative_area_level_3')
        })
        const comuna = filtered_comuna.length
          ? filtered_comuna[0].long_name
          : ''
        agency.name = `${agency.name} - ${comuna} - ${region}`
        return `${comuna}, ${region}`
      } else if (!!locator.adr_address) {
        const split = locator.adr_address.split(',')
        const regex = /(<([^>]+)>)/gi
        const comuna = split[1].replace(regex, '')
        const region = split[2].replace(regex, '')
        return `${comuna}, ${region}`
      } else {
        return `${locator.vicinity}`
      }
    } else {
      return ''
    }
  }

  const handleComponentByCategory = () => {
    switch (singleExperience.category) {
      case 'RESTAURANT':
        return (
          <RestaurantMenu agency={agency} singleExperience={singleExperience} />
        )

      case 'ECOMMERCE':
        return <Ecommerce agency={agency} singleExperience={singleExperience} />

      case 'AGENCY':
        return (
          <ExperienceInformationAgency
            hotDeal={reservationDetail}
            singleExperience={singleExperience}
            gallery={gallery}
          />
        )
      case 'PROGRAM':
        return (
          <ExperienceInformationPrograms
            hotDeal={reservationDetail}
            singleExperience={singleExperience}
            gallery={gallery}
            // experiencesGallery={galleryExperiencesProgram}
          />
        )
      case 'TAILORMADE':
        return (
          <ExperienceInformationPrograms
            hotDeal={reservationDetail}
            singleExperience={singleExperience}
            gallery={gallery}
            // experiencesGallery={galleryExperiencesProgram}
          />
        )

      case 'HOTEL':
        return (
          <ExperienceInformationHotel
            hotDeal={reservationDetail}
            singleExperience={singleExperience}
            gallery={gallery}
          />
        )

      default:
        return
    }
  }

  const triggerEvent = (element, eventName) => {
    const event = new Event(eventName)
    element.dispatchEvent(event)
  }

  function changeLanguage() {
    document.querySelector('.goog-te-combo').value = lang
    if (lang === 'en') {
      setLang('es')
    }
    if (lang === 'es') {
      setLang('en')
    }
    triggerEvent(document.querySelector('.goog-te-combo'), 'change')
  }

  return (
    <>
      <MetaTags>
        <title>{`${title}`}</title>
        <meta
          name="description"
          content={
            !!singleExperience.shortDescription
              ? singleExperience.shortDescription
              : 'Digitalizamos y agrupamos a los pequeños emprendedore turísticos de Chile para mostrarlos a todos y que vendan directamente a precios justos.'
          }
        />
        <meta
          name="og:description"
          content={
            !!singleExperience.shortDescription
              ? singleExperience.shortDescription
              : 'Digitalizamos y agrupamos a los pequeños emprendedore turísticos de Chile para mostrarlos a todos y que vendan directamente a precios justos.'
          }
        />
        <meta property="og:title" content={title} />
        <meta property="og:image" content={agencyData.logo} />
        <meta property="twitter:image" content={agencyData.logo} />
        {!!agency.gsv ? (
          <meta name="google-site-verification" content={agency.gsv} />
        ) : (
          ''
        )}
      </MetaTags>
      <h1 style={{ display: 'none' }}>{h1Hidden}</h1>
      <h2 style={{ display: 'none' }}>{h2Hidden}</h2>
      <Box>
        {!!isLoading ? (
          <Container>
            <Box display="flex" justifyContent="center">
              <CircularProgress />
            </Box>
          </Container>
        ) : (
          <>
            <AgencyBanner
              logo={
                agency.logo
                  ? agency.logo
                  : agency.settings
                  ? agency.settings.logo
                  : ''
              }
              agencyKey={agency.key}
              name={agency.name}
              bannerImage={
                agency.bannerImage
                  ? agency.bannerImage
                  : agency.settings
                  ? agency.settings.banner?.url
                  : ''
              }
              experienceName={singleExperience.name}
              experienceCategory={getNameCategory(singleExperience.category)}
              bannerModel={2}
              reviews={reviews}
            />
{/* 
            <>
              <center>
                <div className="switch">
                  <input
                    id="language-toggle"
                    class="check-toggle check-toggle-round-flat"
                    type="checkbox"
                  />
                  <label
                    htmlFor="language-toggle"
                    onClick={() => changeLanguage()}
                  ></label>
                  <span className="on">
                    <LazyLoadImage
                      width="100%"
                      height="100%"
                      src={chileFlag}
                      id="flag"
                      alt="usa"
                      className="lazyload"
                    />
                  </span>
                  <span className="off">
                    <LazyLoadImage
                      src={usaFlag}
                      width="100%"
                      height="100%"
                      id="flag"
                      alt="chile"
                      className="lazyload"
                    />
                  </span>
                </div>
              </center>
            </> */}

            <Container style={{ marginTop: '1.5rem' }}>
              {handleComponentByCategory()}
            </Container>
          </>
        )}
      </Box>
      <Footer />
    </>
  )
}

export default Details
